module.exports = __webpack_public_path__ + "static/media/217-Abspann_ID_3.bbc32147.mp3";